import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { Shield, ScrollText } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import { useAuthStore } from '../../auth/store/authStore'
import { PlatformAdminsTab } from './PlatformAdminsTab'
import { AuditLogsTab } from './AuditLogsTab'

type PlatformTab = 'admins' | 'audit-logs'

const TABS: { value: PlatformTab; label: string; Icon: LucideIcon }[] = [
  { value: 'admins', label: 'Platform Admins', Icon: Shield },
  { value: 'audit-logs', label: 'Audit Logs', Icon: ScrollText },
]

export function PlatformAdminPage(): JSX.Element {
  const user = useAuthStore((s) => s.user)
  const location = useLocation()
  const navigate = useNavigate()
  const activeTab: PlatformTab = location.pathname.includes('audit-logs') ? 'audit-logs' : 'admins'

  if (!user?.is_platform_admin) {
    return <Navigate to="/unauthorized" replace />
  }

  const TAB_PATHS: Record<PlatformTab, string> = {
    admins: '/platform-admin/admins',
    'audit-logs': '/platform-admin/audit-logs',
  }

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Platform Administration</h1>
        <p className="mt-1 text-sm text-gray-500">
          Manage platform-level admins and review the full audit trail
        </p>
      </div>

      <div className="flex border-b border-gray-200">
        {TABS.map(({ value, label, Icon }) => (
          <button
            key={value}
            type="button"
            onClick={() => navigate(TAB_PATHS[value])}
            className={`flex items-center gap-2 border-b-2 px-5 py-3 text-[14px] transition-colors ${
              activeTab === value
                ? 'border-brand-green font-semibold text-gray-900'
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            <Icon size={16} />
            {label}
          </button>
        ))}
      </div>

      <div className="mt-6">
        {activeTab === 'admins' && <PlatformAdminsTab />}
        {activeTab === 'audit-logs' && <AuditLogsTab />}
      </div>
    </div>
  )
}
